import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface FieldDocuments {
  name: string;
  api_token: string;
}

export interface FieldDocumentsListInfor {
  errors: unknown;
  fieldDocuments: FieldDocuments;
  isAuthenticated: boolean;
}

@Module
export default class FieldDocumentsModule
  extends VuexModule
  implements FieldDocumentsListInfor
{
  errors = {};
  fieldDocuments = {} as FieldDocuments;
  isAuthenticated = !!JwtService.getToken();

  get FieldDocuments() {
    return this.fieldDocumentsListData;
  }

  @Mutation
  [Mutations.FIELD_DOCUMENTS_LIST_DATA](FieldDocuments) {
    this.fieldDocumentsListData = FieldDocuments;
  }

  @Action
  [Actions.FIELD_DOCUMENTS_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("/field_document", payload)
        .then((data) => {
          this.context.commit(Mutations.FIELD_DOCUMENTS_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.FIELD_DOCUMENT_CREATE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("field_document/upsert", payload)
        .then((data) => {
          this.context.commit(Mutations.FIELD_DOCUMENTS_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.FIELD_DOCUMENT_UPDATE](payload) {
    const id = payload.get("id");
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail("/field_document", "upsert", id, payload)
        .then((data) => {
          this.context.commit(Mutations.FIELD_DOCUMENTS_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.FIELD_DOCUMENT_DELETE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail(
        "/field_document",
        payload,
        "delete",
        payload
      )
        .then((data) => {
          this.context.commit(Mutations.FIELD_DOCUMENTS_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }
}
